import { Injectable } from "@angular/core";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { RankingPagedResponse } from "app/shared/models/ei-models";

@Injectable({
  providedIn: 'root'
})
export class RankingService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Ranking/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Lista ranking de uma imobiliária
   * GET api/Ranking/Listar/{imobiliariaId}?usuarioId=&page=&pageSize=
   */
  listar(imobiliariaId: number, usuarioId?: number, page = 1, pageSize = 50): Observable<RankingPagedResponse> {
    const url = this.controllerEndpoint.concat('Listar/', imobiliariaId.toString());
    const params: any = { 
      page: page.toString(), 
      pageSize: pageSize.toString() 
    };
    
    // Adiciona usuarioId apenas se fornecido (para destacar o usuário atual)
    if (usuarioId) {
      params.usuarioId = usuarioId.toString();
    }

    return this.httpClient.get<RankingPagedResponse>(url, {
      headers: this.getHeader(true),
      params
    });
  }
}